import { LOG_LEVEL_ERROR, LOG_LEVEL_INFO } from './logs';
import { isDev } from '../environment/envs';

const isListenFesLocally = process.env.REACT_APP_FES_LOCAL === 'true' || process.env.STORYBOOK_FES_LOCAL === 'true';

const FRONTEND_SERVICE = '/fe';
const FRONTEND_SERVICE_API = '/api';

const FES_LOG_INFO_API = '/fes-log/info';
const FES_LOG_ERROR_API = '/fes-log/error';

const FES_LOCAL_URL = 'http://localhost:5000';

const FRONTEND_SERVICE_BASE_DEV = isListenFesLocally ? FES_LOCAL_URL : FRONTEND_SERVICE;

export const FRONTEND_SERVICE_BASE_STATIC_URL = isDev ? FRONTEND_SERVICE_BASE_DEV : FRONTEND_SERVICE;
export const FRONTEND_SERVICE_BASE_URL = `${FRONTEND_SERVICE_BASE_STATIC_URL}${FRONTEND_SERVICE_API}`;

const getLogUrl = logLevel => {
  switch (logLevel) {
    case LOG_LEVEL_ERROR:
      return FES_LOG_ERROR_API;
    case LOG_LEVEL_INFO:
      return FES_LOG_INFO_API;
    default:
      return FES_LOG_INFO_API;
  }
};

export const LOG_TO_KIBANA = logLevel => `${FRONTEND_SERVICE_BASE_URL}${getLogUrl(logLevel)}`;
